import { Component } from "@angular/core";

@Component({
	selector: "caass-Vpp3",
	templateUrl: "./vpp3.component.html",
})
export class Vpp3Component {}
